import React from "react";
import { useCardPreview } from "../../contexts/CardPreviewContext";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const PreviewSafeButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled,
  tabIndex,
  "aria-hidden": ariaHidden,
  type,
  ...rest
}) => {
  const isPreview = useCardPreview();

  if (isPreview) {
    return (
      <button
        {...rest}
        type={type ?? "button"}
        disabled
        tabIndex={-1}
        aria-hidden="true"
      >
        {children}
      </button>
    );
  }

  return (
    <button
      {...rest}
      type={type ?? "button"}
      onClick={onClick}
      disabled={disabled}
      tabIndex={tabIndex}
      aria-hidden={ariaHidden}
    >
      {children}
    </button>
  );
};

export default PreviewSafeButton;
